import { RouteObject } from 'react-router-dom';
import { RouteMeta } from '@/pages/routes';

const route: RouteObject = {
	path: 'expense',
	lazy: async () => ({ Component: (await import('@/modules/expense/Layout')).default }),
	loader: () => ({
		meta: {
			title: 'Expense',
			to: { id: 'expense' },
			htmlTitlePattern: '#title :: Expense ',
		} as RouteMeta,
	}),
	children: [
		{
			path: '',
			index: true,
			id: 'expense',
			loader: () => ({
				meta: {
					title: 'Home',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/expense/pages/Home')).default }),
		},
		{
			path: 'list',
			index: true,
			id: 'expenseList',
			loader: () => ({
				meta: {
					title: 'List',
					disabled: true,
				} as RouteMeta,
			}),
			lazy: async () => ({ Component: (await import('@/modules/expense/pages/List')).default }),
		},
	],
};
export default route;
